import React from 'react'
import { withNamespaces } from 'react-i18next'
import { ScanQrCode } from 'lucide-react'
import AppHeader from '../containers/AppHeader'

class ScanQRView extends React.Component {
  render() {
    const { t } = this.props

    const content = (
      <div className="unified-form mt-4">
        <ScanQrCode className="rental-phoneIcon" strokeWidth={1} />
        <h4 className="lockTitle mt-3">
          <span className="text-vw-semidark">{t('ESCANEA EL CÓDIGO QR')}</span>
        </h4>
        <p className="text-center text-vw-semidark mt-3" style={{ fontSize: '1rem', padding: '0 1rem' }}>
          {t('Para iniciar el proceso de reserva, escanea el código QR que encontrarás en la zona de taquillas con la cámara de tu teléfono.')}
        </p>
      </div>
    )

    return (
      <div className="rentalBackground">
        <AppHeader />

        {/* Smartphone layout */}
        <div className="lockerContainer smartphone">
          <br />
          {content}
        </div>

        {/* Desktop layout */}
        <div className="lockerContainer pc">
          <div className="d-flex justify-content-center">
            <div className="col-6">
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withNamespaces()(ScanQRView)
